const MailOpenIcon = () => {
  return (
    <svg fill="none" viewBox="0 0 33 32" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.66675 11.6667L16.3334 6.33337L26.0001 11.6667V23C26.0001 24.4728 24.8062 25.6667 23.3334 25.6667H9.33342C7.86066 25.6667 6.66675 24.4728 6.66675 23V11.6667Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M25.6669 12L18.0002 17.6667H14.6669L7.00024 12"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  )
}

export default MailOpenIcon
